import React from 'react';
import {
    Autocomplete,
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Stack,
    Tab,
    Tabs,
    TextField,
} from '@mui/material';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';

import AppDatePicker from '../../shared/AppDatePicker';

export default function FinancialReportHeaderCard({
    mode,
    filters,
    availableCostCenters,
    loading,
    hasData,
    onModeChange,
    onFromChange,
    onToChange,
    onCostCentersChange,
    onApplyFilters,
    onExport,
}) {
    return (
        <Card>
            <CardHeader title="Finanzberichte" subheader="BWA und GuV / EÜR mit Drill-Down" />
            <Divider />
            <CardContent>
                <Tabs
                    value={mode}
                    onChange={(_, value) => onModeChange(value)}
                    sx={{ mb: 2 }}
                >
                    <Tab label="BWA" value="bwa" />
                    <Tab label="GuV / EÜR" value="pnl" />
                </Tabs>
                <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems="flex-end">
                    <AppDatePicker label="Von" value={filters.from} onChange={onFromChange} />
                    <AppDatePicker label="Bis" value={filters.to} onChange={onToChange} />
                    <Autocomplete
                        multiple
                        sx={{ minWidth: 240 }}
                        options={availableCostCenters}
                        value={filters.costCenters}
                        onChange={(_, value) => onCostCentersChange(value)}
                        renderInput={(params) => <TextField {...params} label="Kostenstellen" placeholder="Filtern" />}
                    />
                    <Box sx={{ flexGrow: 1 }} />
                    <Button
                        variant="outlined"
                        startIcon={<RefreshRoundedIcon />}
                        onClick={onApplyFilters}
                        disabled={loading}
                    >
                        Anwenden
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<DownloadRoundedIcon />}
                        onClick={onExport}
                        disabled={!hasData}
                    >
                        Export
                    </Button>
                </Stack>
            </CardContent>
        </Card>
    );
}
